import script from "./AudioVisualizer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioVisualizer.vue?vue&type=script&setup=true&lang=ts"

import "./AudioVisualizer.vue?vue&type=style&index=0&id=b7a64230&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7a64230"]])

export default __exports__